
const digest = 'a0bf2d1c8b4fb6b41b43c78fbe09243168458a6e551154e8b61801829ccd19ae';
const classes = {"wrapper":"_wrapper_1eu7i_1","header":"_header_1eu7i_10"};
const css = `._wrapper_1eu7i_1 {
  padding: 20px;
  border-top: 1px solid #e6e7eb;
  min-width: 50%;
}
._wrapper_1eu7i_1:not(:last-child) {
  border-right: 1px solid #e6e7eb;
}

._header_1eu7i_10 {
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  